import React, { FC } from 'react';
import {
  Britz,
  JustGo,
  MAUI,
  Mighty,
  MonteRV,
  RoadBear,
  ColoredMonteRV,
  ColoredRoadBear,
  ColoredBritz,
  ColoredMighty,
  ColoredJustGo,
  ColoredCheapa,
  ColoredHippie,
  THL,
  ColoredApollo,
  ColoredBunk,
  Apollo,
  Bunk,
  Cheapa,
  Hippie,
  Canadream,
  QantasFrequentFlyer,
} from './Logos';
import styled, { css } from 'styled-components';

export const LogoName = {
  britz: 'britz',
  justGo: 'justGo',
  apollo: 'apollo',
  bunk: 'bunk',
  maui: 'maui',
  mighty: 'mighty',
  monteRV: 'monteRV',
  roadBear: 'roadBear',
  cheapa: 'cheapa',
  hippie: 'hippie',
  canadream: 'canadream',
  coloredMonteRV: 'coloredMonteRV',
  coloredRoadBear: 'coloredRoadBear',
  coloredBritz: 'coloredBritz',
  ColoredMighty: 'coloredMighty',
  ColoredJustGo: 'coloredJustGo',
  ColoredApollo: 'coloredApollo',
  ColoredBunk: 'coloredBunk',
  coloredCheapa: 'coloredCheapa',
  coloredHippie: 'coloredHippie',
  thl: 'thl',
  qantasFrequentFlyer: 'qantasFrequentFlyer',
} as const;

type logoNameType = typeof LogoName[keyof typeof LogoName];

type Logos = { [key in logoNameType]: JSX.Element };

export const logos: Logos = {
  britz: Britz,
  justGo: JustGo,
  maui: MAUI,
  mighty: Mighty,
  monteRV: MonteRV,
  roadBear: RoadBear,
  apollo: Apollo,
  bunk: Bunk,
  cheapa: Cheapa,
  hippie: Hippie,
  canadream: Canadream,
  coloredMonteRV: ColoredMonteRV,
  coloredRoadBear: ColoredRoadBear,
  coloredBritz: ColoredBritz,
  coloredMighty: ColoredMighty,
  coloredJustGo: ColoredJustGo,
  coloredApollo: ColoredApollo,
  coloredBunk: ColoredBunk,
  coloredCheapa: ColoredCheapa,
  coloredHippie: ColoredHippie,
  thl: THL,
  qantasFrequentFlyer: QantasFrequentFlyer,
};

interface LogoProps {
  name: string;
  title?: string;
  description?: string;
  className?: string;
  isInverted?: boolean;
}

export const Logo: FC<LogoProps> = ({
  name,
  title,
  description,
  className,
  isInverted,
}) => {
  const viewBox = getViewBox(name);

  return (
    <StyledSvg
      className={className}
      isInverted={isInverted}
      viewBox={viewBox}
      role="img"
    >
      <title>{title}</title>
      <desc>{description}</desc>
      {logos[name]}
    </StyledSvg>
  );
};

function getViewBox(name: string) {
  switch (name) {
    case LogoName.britz:
    case LogoName.coloredBritz:
      return '0 0 133.13 81.01';
    case LogoName.maui:
      return '0 0 291 114';
    case LogoName.mighty:
      return '0 0 646 270';
    case LogoName.monteRV:
      return '0 0 336.52 54.05';
    case LogoName.justGo:
      return '0 0 280 244';
    case LogoName.roadBear:
      return '0 0 562 281';
    case LogoName.apollo:
    case LogoName.ColoredApollo:
      return '0 0 3799.33 1143.33';
    case LogoName.cheapa:
      return '0 0 108 27';
    case LogoName.hippie:
      return '0 0 62 29';
    case LogoName.canadream:
      return '0 0 66 25';
    case LogoName.bunk:
      return '0 0 34 33';
    case LogoName.coloredRoadBear:
      return '0 0 57 30';
    case LogoName.coloredMonteRV:
      return '0 0 76 30';
    case LogoName.ColoredMighty:
      return '0 0 49 20';
    case LogoName.ColoredJustGo:
      return '0 0 33 28';
    case LogoName.ColoredBunk:
      return '0 0 33 33';
    case LogoName.coloredCheapa:
      return '0 0 74 20';
    case LogoName.coloredHippie:
      return '0 0 30 25';
    case LogoName.qantasFrequentFlyer:
      return '0 0 80 32';
    case LogoName.thl:
      return '0 0 206.35 97.78';
    default:
      return '0 0 214 99';
  }
}

const StyledSvg = styled.svg<{ isInverted?: boolean }>`
  width: 100%;
  fill: #231f20;

  ${({ isInverted }) =>
    isInverted &&
    css`
      fill: ${({ theme }) => theme?.colors?.white};
    `}
`;
